var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-edit page" },
    [
      _c("management-page-back-arrow", {
        on: {
          buttonClick: function($event) {
            return _vm.$router.back()
          }
        }
      }),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "page-section" },
            [
              !_vm.oneSectionOnly
                ? _c(
                    "v-layout",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: {
                        row: "",
                        "justify-space-between": "",
                        "align-start": "",
                        wrap: ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md5: "", lg4: "" } },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "page-header mb-2",
                              attrs: { column: "", "align-start": "" }
                            },
                            [
                              _c("span", { staticClass: "page-title mb-2" }, [
                                _vm._v(_vm._s(_vm.pageTitle) + " ")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "buttons" },
                                [
                                  _vm.showEdit
                                    ? _c("view-page-button", {
                                        attrs: {
                                          label: _vm.$t("Edit"),
                                          icon: "edit",
                                          disabled: _vm.editDisabled
                                        },
                                        on: { click: _vm.editItem }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showDelete
                                    ? _c("view-page-button", {
                                        attrs: {
                                          label: _vm.$t("Delete"),
                                          icon: "delete",
                                          disabled: _vm.deleteDisabled
                                        },
                                        on: { click: _vm.deleteItem }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("leftSideContent")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.divider
                        ? _c("v-divider", { attrs: { vertical: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "", lg7: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "page-header" },
                            [_vm._t("rightSideHeader")],
                            2
                          ),
                          _vm._v(" "),
                          _vm._t("rightSideContent")
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _c(
                    "v-layout",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { column: "" }
                    },
                    [
                      _c("v-layout", { staticClass: "page-header" }, [
                        _c("span", { staticClass: "page-title" }, [
                          _vm._v(_vm._s(_vm.pageTitle) + " ")
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._t("wholeSection")
                    ],
                    2
                  ),
              _vm._v(" "),
              _vm.withButtons
                ? _c(
                    "div",
                    { staticClass: "action-buttons" },
                    [
                      _vm.toggleFieldButton && !_vm.isConsumable
                        ? _c("management-button", {
                            staticStyle: { margin: "0 auto 0 0" },
                            attrs: {
                              type: "execute",
                              label: _vm.toggleButtonLabel
                            },
                            on: {
                              buttonClick: function($event) {
                                return _vm.$emit("toggleField")
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("management-button", {
                        attrs: { type: "cancel", label: _vm.$t("Cancel") },
                        on: {
                          buttonClick: function($event) {
                            return _vm.$router.back()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("management-button", {
                        attrs: {
                          type: "execute",
                          label: _vm.submitButtonLabel,
                          disabled: _vm.submitButtonDisabled,
                          "list-missing-fields": _vm.listMissingFields
                        },
                        on: { buttonClick: _vm.submit }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("dialogBox"),
      _vm._v(" "),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "is-full-page": false,
          color: "accent"
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70199287", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70199287","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/NewEditPage/NewEditPage.vue
// module id = null
// module chunks = 